import { COLOR_KEYS } from '../../../constants';
import { ScrollingTweetsSectionProps } from './ScrollingTweetsSection';

export const DEFAULT_VALUES: ScrollingTweetsSectionProps = {
  backgroundColor: COLOR_KEYS.bolt,
  heading: 'This is what automation feels like',
  tweets: [
    {
      name: 'John Smith',
      handle: '@johnsmith',
      body:
        '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>',
    },
    {
      name: 'John Smith',
      handle: '@johnsmith',
      body:
        '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>',
      mediaUrl: 'https://cdn.zappy.app/5def3048ce746b5c8f2cab995a6eb46a.png',
    },
    {
      name: 'John Smith',
      handle: '@johnsmith',
      body:
        '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>',
      mediaUrl: 'https://cdn.zappy.app/5def3048ce746b5c8f2cab995a6eb46a.png',
    },
    {
      name: 'John Smith',
      handle: '@johnsmith',
      body:
        '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>',
    },
    {
      name: 'John Smith',
      handle: '@johnsmith',
      body:
        '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>',
    },
    {
      name: 'John Smith',
      handle: '@johnsmith',
      body:
        '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>',
      mediaUrl: 'https://cdn.zappy.app/5def3048ce746b5c8f2cab995a6eb46a.png',
    },
    {
      name: 'John Smith',
      handle: '@johnsmith',
      body:
        '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>',
      mediaUrl: 'https://cdn.zappy.app/5def3048ce746b5c8f2cab995a6eb46a.png',
    },
    {
      name: 'John Smith',
      handle: '@johnsmith',
      body:
        '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>',
    },
  ],
};
